import script from "./MintBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./MintBlock.vue?vue&type=script&setup=true&lang=js"

import "./MintBlock.vue?vue&type=style&index=0&id=fb9998de&lang=sass"

const __exports__ = script;

export default __exports__